(function () {
  var cfgEl = document.getElementById('fitaz-promo-bar-ab-analytics-config');
  if (!cfgEl) return;

  var CFG;
  try {
    CFG = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }

  var GA4 = CFG.ga4_id || 'G-Y0VT2QGQW7';
  var COOKIE = 'promo_bar_ab';
  var STORAGE_KEY = 'promo_bar_ab';
  var SCROLL_MARKS = [25, 50, 75, 90, 100];
  var WLR_PATH = CFG.wlr_path || '/products/weightloss-reset';
  var CONTROL_PREFIX = CFG.control_prefix || 'Next Challenge Starts:';
  var VARIANT_PREFIX = CFG.variant_prefix || 'Intake Closes:';
  var BAR_CLICK_KEY = 'fitaz_promo_bar_clicked';
  var REFERRER_PAGE_KEY = 'fitaz_promo_bar_referrer_page';

  function readCookie(name) {
    try {
      var parts = document.cookie.split(';');
      for (var i = 0; i < parts.length; i++) {
        var chunk = parts[i].trim();
        if (chunk.indexOf(name + '=') === 0) {
          return decodeURIComponent(chunk.slice(name.length + 1));
        }
      }
    } catch (e) {}
    return '';
  }

  function readStorage() {
    try {
      var value = window.localStorage.getItem(STORAGE_KEY) || '';
      if (value === 'control' || value === 'variant') return value;
    } catch (e) {}
    return '';
  }

  function resolveArm() {
    if (window.__fitazPromoBarAb && (window.__fitazPromoBarAb.arm === 'control' || window.__fitazPromoBarAb.arm === 'variant')) {
      return window.__fitazPromoBarAb.arm;
    }
    var root = document.documentElement;
    if (root && root.classList) {
      if (root.classList.contains('promo-bar-ab--variant')) return 'variant';
      if (root.classList.contains('promo-bar-ab--control')) return 'control';
    }

    var stored = readCookie(COOKIE);
    if (stored !== 'control' && stored !== 'variant') {
      stored = readStorage();
    }
    if (stored === 'control' || stored === 'variant') return stored;
    return 'unknown';
  }

  var ARM = resolveArm();

  function barCopy() {
    return ARM === 'variant' ? VARIANT_PREFIX : CONTROL_PREFIX;
  }

  function baseParams(extra) {
    return Object.assign(
      {
        send_to: GA4,
        promo_bar_ab_variant: ARM,
        bar_copy: barCopy(),
        page_type: CFG.page_type || '',
        site_market: CFG.site_market
      },
      extra || {}
    );
  }

  function send(name, extra) {
    var params = baseParams(extra);
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params);
      } else {
        window.dataLayer = window.dataLayer || [];
        var payload = { event: name };
        Object.keys(params).forEach(function (key) {
          payload[key] = params[key];
        });
        window.dataLayer.push(payload);
      }
    } catch (err) {}
  }

  function once(key) {
    try {
      if (sessionStorage.getItem(key)) return false;
      sessionStorage.setItem(key, '1');
      return true;
    } catch (e) {
      return true;
    }
  }

  function setUserProperties() {
    if (typeof window.gtag !== 'function') return;
    if (ARM !== 'control' && ARM !== 'variant') return;
    try {
      window.gtag('set', 'user_properties', {
        promo_bar_ab_variant: ARM
      });
      window.__fitazPromoBarAb = { arm: ARM };
    } catch (e) {}
  }

  function syncCartAttributes() {
    if (ARM !== 'control' && ARM !== 'variant') return;
    if (typeof window.fitazPromoBarApplyAbAttribution === 'function') {
      window.fitazPromoBarApplyAbAttribution();
    }
  }

  function normalizeHref(href) {
    if (!href) return '';
    try {
      var url = new URL(href, window.location.origin);
      return url.pathname.replace(/\/+$/, '') || '/';
    } catch (e) {
      return href.split('?')[0].split('#')[0];
    }
  }

  function bindBarVisible() {
    var bar = document.querySelector('[data-fitaz-promo-bar-ab-target]');
    if (!bar || typeof IntersectionObserver !== 'function') return;

    var viewKey = 'fitaz_promo_bar_visible_' + ARM;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (!once(viewKey)) {
            observer.disconnect();
            return;
          }
          send('promo_bar_visible');
          observer.disconnect();
        });
      },
      { threshold: [0.5] }
    );
    observer.observe(bar);
  }

  function bindBarClicks() {
    document.addEventListener(
      'click',
      function (e) {
        var target = e.target;
        if (!target || !target.closest) return;

        var bar = document.querySelector('[data-fitaz-promo-bar-ab-target]');
        if (!bar || !bar.contains(target)) return;

        var fullLink = target.closest('[class*="promo-countdown-bar__full-link"]');
        var cta = target.closest('[class*="promo-countdown-bar__cta"]');
        if (!fullLink && !cta) return;

        var clickTarget = cta ? 'cta' : 'full_link';
        var linkEl = fullLink || cta;
        var href = linkEl ? linkEl.getAttribute('href') || '' : '';

        send('promo_bar_click', {
          click_target: clickTarget,
          link_href: href
        });

        try {
          sessionStorage.setItem(BAR_CLICK_KEY, '1');
          sessionStorage.setItem(REFERRER_PAGE_KEY, CFG.page_type || '');
        } catch (err) {}
      },
      true
    );
  }

  function checkWlrLanding() {
    var path = normalizeHref(window.location.pathname);
    var wlrPath = normalizeHref(WLR_PATH);
    if (path !== wlrPath) return;

    var clicked = false;
    var referrerPage = '';
    try {
      clicked = sessionStorage.getItem(BAR_CLICK_KEY) === '1';
      referrerPage = sessionStorage.getItem(REFERRER_PAGE_KEY) || '';
    } catch (e) {}

    if (!clicked) return;
    if (!once('fitaz_promo_bar_wlr_landing_' + ARM)) return;

    send('promo_bar_wlr_landing', {
      referrer_page_type: referrerPage
    });
  }

  function bindScrollDepth() {
    var fired = {};
    function scrollPercent() {
      var doc = document.documentElement;
      var body = document.body;
      var scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
      var scrollHeight = Math.max(body.scrollHeight, doc.scrollHeight) - window.innerHeight;
      if (scrollHeight <= 0) return 100;
      return Math.min(100, Math.round((scrollTop / scrollHeight) * 100));
    }

    function onScroll() {
      var pct = scrollPercent();
      SCROLL_MARKS.forEach(function (mark) {
        if (pct < mark || fired[mark]) return;
        fired[mark] = true;
        send('promo_bar_scroll_depth', { scroll_percent: mark });
      });
      if (fired[100]) {
        window.removeEventListener('scroll', onScroll);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init() {
    if (ARM !== 'control' && ARM !== 'variant') return;

    var viewKey = 'fitaz_promo_bar_ab_view_' + ARM;
    if (once(viewKey)) {
      setUserProperties();
      syncCartAttributes();
      send('promo_bar_ab_view');
    }

    bindBarVisible();
    bindBarClicks();
    bindScrollDepth();
    checkWlrLanding();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
